import i18next from 'i18next';

export default function i18n({
  locale,
  resources,
  defaultNS = 'translation',
}: {
  locale: string;
  resources: Record<string, string>;
  defaultNS?: string;
}) {
  const instance = i18next;
  i18next.init({
    keySeparator: '$',
    lng: locale,
    defaultNS,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [locale]: resources,
    },
  });
  return instance;
}
